import format from 'date-fns/format';

import { serviceTypes } from '../../../store/initData/services';
import i18n from '../../../i18n';

export const convWorkshopToOption = (
  service,
  ws,
  mapPageTexts,
  index = null,
) => {
  if (!ws) {
    return ws;
  }

  if (service === serviceTypes.workshop) {
    const days = i18n.t('mapPage.daysFromMonday');
    const types = {
      PERIODIC: mapPageTexts.PERIODIC,
      DEMO: mapPageTexts.DEMO,
    };

    const cyclicDay = parseInt(ws.cyclic_day);
    //days are numbered 1 to 7, monday to sunday (https://www.timeanddate.com/calendar/days/)
    const customGroupName = ws.custom_group_name
      ? `${index + 1} (${ws.custom_group_name})`
      : `${index + 1}`;
    const dayText =
      cyclicDay >= 1 && cyclicDay <= 7
        ? `${mapPageTexts.dayText} ${customGroupName} ${days[cyclicDay - 1]}`
        : `${mapPageTexts.dayText} ${customGroupName} - ${i18n.t('mapPage.dayNotSet')}`;

    const hourText = ws.cyclic_hour ? ws.cyclic_hour : i18n.t('mapPage.hourNotSet'); //? ws.cyclic_hour : '--:--'
    const text = `${dayText} ${hourText}`;

    const type = types['PERIODIC'];
    const value = ws.id;

    return { value: value, text: text, type: type, ws: ws };
  }
  else {
    const text = function(ws) {
      const namePrefix = ws.name ? `${ws.name}, ` : '';
      if (ws.start_time) {
        return `${namePrefix}${format(new Date(ws.start_date), 'dd.MM')}-${format(
          new Date(ws.end_date),
          'dd.MM',
        )}, ${ws.age}, ${ws.start_time}-${ws.end_time}, ${ws.typeName}`;
      }
      else {
      return `${namePrefix}${format(new Date(ws.start_date), 'dd.MM')}-${format(
        new Date(ws.end_date),
        'dd.MM',
      )}, ${ws.age}, ${ws.typeName}`;
      }
    };

    return { value: ws.id, text: text(ws), ws: ws };
  }
};

export const sortByCyclicDate = (list) => {
  list.sort((a, b) => {
    if (a.cyclic_day - b.cyclic_day !== 0) {
      return a.cyclic_day - b.cyclic_day;
    }

    return (
      new Date('1970/01/01 ' + a.cyclic_hour) -
      new Date('1970/01/01 ' + b.cyclic_hour)
    );
  });
};

export const sortByStartDate = (list) => {
  list.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
};
